import { useMutation } from '@tanstack/react-query';
import { AttachmentReportService } from '@/infra/services/attachment';

interface UpdateAttachmentParams {
	id: string;
	company_id: string;
	description: string;
	organization_id: string;
}

const Service = AttachmentReportService.getInstance();

export function useUpdateAttachment() {
	return useMutation({
		mutationFn: (params: UpdateAttachmentParams) => Service.update(params)
	});
}
